import { render, staticRenderFns } from "./GoodsEdit.vue?vue&type=template&id=fbfabcf2&scoped=true&"
import script from "./GoodsEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfabcf2",
  null
  
)

export default component.exports